<template>
  <a-spin :spinning="spinning" size="large">
    <div class="post-detail" v-if="detail">
      <template>
        <a-row class="row" type="flex" justify="space-between" align="middle">
          <a-col class="col gap">
            <span class="title">{{ detail.name }}</span>
            <span class="ji" v-if="detail.is_urgent == '1'">急</span
            ><span class="hc" v-if="detail.is_mhc == '1'">多HC</span>
          </a-col>
          <a-col class="col col2">
            <span class="time">
              <icon-font type="riqi" />
              更新时间：{{ detail.refreshed_at }}
            </span>
          </a-col>
        </a-row>
        <a-row class="row" type="flex" justify="space-between" align="middle">
          <a-col class="col">
            <span class="salary">
              {{
                `${detail.hunter_salary_min}-${detail.hunter_salary_max}万`
              }}</span
            >
            <a-divider type="vertical" />
            <span>{{ detail.job_areas | formatCity }}</span>
            <a-divider type="vertical" />
            <span>招聘{{ detail.quantity }}人</span>
            <a-divider type="vertical" />
            <span>{{ detail.experience_name }}经验</span>
            <a-divider type="vertical" />
            <span>{{ detail.education_name }}</span>
          </a-col>
        </a-row>
        <a-row class="row" type="flex" justify="space-between" align="middle">
          <a-col class="col">
            <span>{{ detail.company.name }}</span>
          </a-col>
          <a-col class="col">
            被浏览：{{ detail.num_views }}人 被接单：{{ detail.count_posts }}人
          </a-col>
        </a-row>
        <a-row
          class="row theme"
          type="flex"
          justify="space-between"
          align="middle"
        >
          <a-col class="col">
            <a-row>
              <!-- 悬赏职位 -->
              <a-col v-if="detail.is_reward_type == '1'">
                <a-row type="flex" align="middle">
                  <a-col>
                    <icon-font
                      type="xuanshangjine"
                      :style="{
                        color: '#F6B502',
                        fontSize: '20px',
                        marginRight: '5px'
                      }"
                    ></icon-font>
                  </a-col>
                  <a-col>
                    <span
                      >悬赏金额：<span style="color:#FC5646">{{
                        detail.reward_amount
                      }}</span
                      >元</span
                    >
                  </a-col>
                  <a-col>
                    <a-divider type="vertical"></a-divider>
                  </a-col>
                  <a-col>悬赏政策：{{ detail.reward_policy_text }}</a-col>
                </a-row>
              </a-col>
              <!-- 猎头职位 -->
              <a-col v-if="detail.is_reward_type == '0'">
                <a-row type="flex" align="middle">
                  <a-col>
                    <icon-font
                      type="xuanshangjine"
                      :style="{
                        color: '#F6B502',
                        fontSize: '20px',
                        marginRight: '5px'
                      }"
                    ></icon-font>
                  </a-col>
                  <!-- 固定佣金 -->
                  <template v-if="detail.hunter_commission_type == '2'">
                    <a-col>{{ `佣金：${detail.hunter_commission_max}` }}</a-col>
                  </template>
                  <!-- 比例佣金 -->
                  <template v-if="detail.hunter_commission_type == '1'">
                    <a-col>{{
                      `佣金：${detail.hunter_commission_min}-${detail.hunter_commission_max}`
                    }}</a-col>
                    <a-col>
                      <a-divider type="vertical"></a-divider>
                    </a-col>
                    <a-col>{{
                      `佣金比例：${detail.hunter_commission_value}%`
                    }}</a-col>
                  </template>

                  <a-col>
                    <a-divider type="vertical"></a-divider>
                  </a-col>
                  <a-col>{{ `保证期：${detail.probation_name}` }}</a-col>
                </a-row>
              </a-col>
            </a-row>
          </a-col>
        </a-row>

        <a-tabs class="tabs" :defaultActiveKey="tab">
          <a-tab-pane tab="职位信息" :key="1" forceRender>
            <info1 v-if = "is_gray == '1' && detail.ai_advices" :info="detail" type="job" @refresh = "getDetail"></info1>
            <info v-else :info="detail" type="job"></info>
          </a-tab-pane>
          <a-tab-pane tab="职位备注" :key="2" forceRender>
            <info1 v-if = "is_gray == '1' && detail.ai_advices" :info="detail" :scrollToDiv="scrollToDiv" type="remarks"></info1>
            <info v-else :info="detail" type="remarks"></info>

          </a-tab-pane>
          <a-tab-pane tab="公司信息" :key="3" forceRender>
            <info :info="detail" type="company"></info>
          </a-tab-pane>
          <a-tab-pane tab="案情通告" :key="4">
            <post-dynamic :id="post_id"></post-dynamic>
          </a-tab-pane>
          <a-tab-pane tab="职位评级" :key="5" forceRender>
            <info :info="detail" type="grade"></info>
          </a-tab-pane>
        </a-tabs>
      </template>
    </div>
  </a-spin>
</template>

<script>
import PostDynamic from "./detail/postDynamic";
import Info from "./detail/info";
import Info1 from "./detail/infoNew.vue";
import Api from "@/api";
export default {
  name: "postDetail",
  data() {
    return {
      detail: null,
      spinning: false,
      is_gray: ''
      // baseURL
    };
  },
  props: {
    id: {
      default: -1
    },
    tab: {
      type: Number,
      default: 1
    },
    scrollToDiv: {
      type: String,
    }
  },
  components: { Info, PostDynamic, Info1 },
  computed: {
    post_id() {
      if (this.id < 0) {
        return this.$route.params.post_id;
      } else {
        return this.id;
      }
    }
  },
  created() {
    this.getDetail();
  },
  mounted() {
    this.is_gray = localStorage.getItem("is_gray");
  },
  methods: {
    async getDetail() {
      this.spinning = true;
      let response = await Api.post.getPostInfo({ job_id: this.post_id });
      if (response.job) {
        this.detail = response.job;
        this.detail.draw_portrait_inactive_tag = this.detail.draw_portrait_inactive_tag ? JSON.parse(this.detail.draw_portrait_inactive_tag) : {};
        this.detail.draw_portrait_active_tag = this.detail.draw_portrait_active_tag ? JSON.parse(this.detail.draw_portrait_active_tag) : {};
        this.$nextTick().then(() => {
          this.spinning = false;
        });
      }
    }
  }
};
</script>

<style lang="scss">
.post-detail {
  // max-width: 1250px;
  margin: 0 30px;
  min-height: 400px;
  padding-top: 40px;
  .row {
    margin-bottom: 10px;
    &.theme {
      padding: 0 20px;
      margin: 20px 0;
      height: 46px;
      background: rgba(53, 181, 254, 0.1);
      border: 1px solid rgba(53, 181, 254, 1);
    }
    .col {
      display: flex;
      align-items: center;
      &.gap {
        span:not(:last-child) {
          margin-right: 16px;
        }
      }
      span {
        display: flex;
        align-items: center;
        &.title {
          font-size: 16px;
          font-weight: bold;
        }
        &.ji {
          font-size: 12px;
          background: #ff6b5d;
          border-radius: 2px;
          height: 18px;
          color: #fff;
          padding: 0 3px;
        }
        &.hc {
          background: #f6b502;
          padding: 0 3px;
          font-size: 12px;
          border-radius: 2px;
          height: 18px;
          color: #fff;
        }
        &.time {
          color: #999;
          .anticon {
            margin-right: 5px;
            font-size: 16px;
          }
        }
        &.salary {
          font-size: 16px;
          color: #fc5646;
        }
        .anticon {
          font-size: 18px;
          margin-right: 5px;
        }
      }
      a {
        display: inline-block;
        margin-left: 20px;
        img {
          margin-right: 5px;
        }
      }
      .ant-btn {
        margin-left: 20px;
      }
    }
  }
  .tabs {
    .ant-tabs-tab {
      font-weight: bold;
      color: #303133;
    }
  }
}
</style>
